module.exports = __webpack_public_path__ + "static/media/conversation_transcription.464a2f9c.png";